import React from "react";
import "../../../css/MonthRental.css";
import mobility from "../../../img/ride.png";

interface MonthRentalProps {
  ThisMonth: number;
  LastMonth: number;
}

const MonthRental = ({ ThisMonth, LastMonth }: MonthRentalProps) => {
  return (
    <div className="rental_month_container">
      <div className="rental_display">
        <img className="mobility" src={mobility} />
        <div className="rental_month_title">今月のレンタル件数</div>
      </div>
      <div className="rental_month_of">
        {ThisMonth} <span className="unit">件</span>
      </div>
      <div className="rental_last_month">
        先月のレンタル件数:
        <span className="rental_last_month_number">
          {LastMonth}
          <span className="unit">件</span>
        </span>
      </div>
    </div>
  );
};

export default MonthRental;
